<template>
  <div class="container">
    <div class="main">
      <div class="title" > 【全球首发】千呼万唤始出来！DIXCEL卡钳横空出世！ </div>
      <div style="color :gray;font-size :14px;text-align:center;margin-bottom:20px"> 2017-6-23 </div>

      <div style="line-height:30px">
        <div style="text-indent:30px"> 经过DIXCEL日本本社近1年的准备，让大家翘首已久的DIXCEL最新产品——高性能制动卡钳终于正式亮相！ </div>  

      </div>

      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2017_06_23/img1.png')"
          fit="fit">
        </el-image>
      </div>
      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2017_06_23/img2.png')"
          fit="fit">
        </el-image>
      </div>
      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2017_06_23/img3.png')"
          fit="fit">
        </el-image>
      </div>
      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2017_06_23/img4.png')"
          fit="fit">
        </el-image>
      </div>
      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2017_06_23/img5.png')"
          fit="fit">
        </el-image>
      </div>
      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2017_06_23/img6.png')"
          fit="fit">
        </el-image>
      </div>
      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2017_06_23/img7.png')"
          fit="fit">
        </el-image>
      </div>
      <div style="width:70%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2017_06_23/img8.png')"
          fit="fit">
        </el-image>
      </div>

      <div style="line-height:30px">
        <div style="text-indent:30px"> 本次发布的卡钳只是DIXCEL进军卡钳市场的第一步，今后将根据实际情况发布更多卡钳产品，敬请期待！ </div>  
        <div style="text-indent:30px"> 同时，针对国内“DIXCEL卡钳旗舰经销店”的招募也将于近日启动。由于是先于日本的先行发售，水货问题能从根本上杜绝，经销商们能够更加安心地销售DIXCEL卡钳产品。有关资讯请关注DIXCEL公众微信号或请致电DIXCEL中国021-64498413。 </div>  
        <div style="text-indent:30px;font-weight:700"> DIXCEL卡钳数据资料 </div>  
        <div style="text-indent:30px"> 卡钳名：未发布 </div>  
        <div style="text-indent:30px"> 卡钳型号：DX4PC41341RT/DX4PC41342LT </div>  
        <div style="text-indent:30px"> 卡钳定位：民用、赛用</div>  
        <div style="text-indent:30px"> 制造工艺：分体锻造（铝）</div>  
        <div style="text-indent:30px"> 产地：日本 </div>  
        <div style="text-indent:30px"> 尺寸：W：278.5mm  D：156.5mm  H：78.5mm </div>  
        <div style="text-indent:30px"> 重量：2.98KG/个 </div>  
        <div style="text-indent:30px"> 颜色：红色 </div>  
        <div style="text-indent:30px"> 活塞数：4POT </div>  
        <div style="text-indent:30px"> 活塞材质：铝（硬质阳极化处理） </div>  
        <div style="text-indent:30px"> 活塞大小：41mm/34mm </div>  
        <div style="text-indent:30px"> 刹车盘对应尺寸：326-370mm </div>  
        <div style="text-indent:30px"> 刹车盘厚度：32mm（最大34mm） </div>  
        <div style="text-indent:30px"> 轮毂对应尺寸：17寸以上（视17寸轮毂设计情况也可能安装） </div>  
        <div style="text-indent:30px"> 刹车皮型号：9185788  Th：18mm </div>  
        <div style="text-indent:30px"> 刹车盘中心合头材质：杜拉铝</div>  
        <div style="text-indent:30px"> 刹车盘中心合头颜色：浅色金黄</div>  
        <div style="text-indent:30px"> 中国发售日期：待定（预计最快发售时间为今年9月）</div>  
        <div style="text-indent:30px"> 中国发售价格：未公布</div>  
        <div style="text-indent:30px;color:orange"> ※以上数据及其他未发布数据以官方最新发布为准。 </div>  
        <div style="text-indent:30px"> DIXCEL中国官网： <a href="www.DIXCEL.cn">www.DIXCEL.cn</a>  </div>  
        <div style="text-indent:30px"> DIXCEL日本官网： <a href="www.DIXCEL.co.jp">www.DIXCEL.co.jp</a> </div>  

      </div>
    </div>
  </div>
</template>


<script>
    export default {
      data() {
        return{

        }
      }
    }
  </script>

<style lang="stylus" scoped>


.container
  background-color : #000
  .box_one 
    width: 100%;

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 62px 50px 52px;
}
  .title {
    color :#ab191d;
    text-align:center;
    margin-bottom 10px
  }


</style>